export default {
    getActivityOffereds: { method: 'get', url: 'activity_offereds' },
    postActivityOffered: { method: 'post', url: 'activity_offereds' },
    putActivityOffered: { method: 'put', url: 'activity_offereds/{id}' },
    deleteActivityOffered: { method: 'delete', url: 'activity_offereds/{id}' },
    deleteActivityOfferedTimeTable: { method: 'delete', url: 'activity_offered_time_tables/{id}' },
    deleteActivityOfferedTeacher: { method: 'delete', url: 'activity_offered_teachers/{id}' },
}
